import React from 'react';
import { ResponsiveContainer, Treemap, Tooltip } from 'recharts';

interface TreemapNode {
  name: string;
  size: number;
  color?: string;
  [key: string]: any;
}

interface Props {
  data: TreemapNode[];
}

const CustomContent = (props: any) => {
  const { x, y, width, height, name, color, size } = props;
  if (!width || !height || width < 8 || height < 8) return null;
  const pct = typeof size === 'number' ? `${size.toFixed(2)}%` : null;

  // Only draw the label at all if the tile has enough width to fit ~3 chars.
  const showLabel = width > 22 && height > 18;
  // Show name + pct on two lines if the tile is tall enough; otherwise just name.
  const showTwoLine = width > 40 && height > 34;
  const fontSize = Math.max(9, Math.min(13, width / 6));

  return (
    <g>
      <rect
        x={x}
        y={y}
        width={width}
        height={height}
        style={{ fill: color || '#3b82f6', stroke: '#0f172a', strokeWidth: 2 }}
      />
      {showLabel && showTwoLine && (
        <>
          <text
            x={x + width / 2}
            y={y + height / 2 - fontSize * 0.55}
            textAnchor="middle"
            dominantBaseline="middle"
            style={{ fill: '#fff', fontSize, fontWeight: 700 }}
          >
            {name}
          </text>
          <text
            x={x + width / 2}
            y={y + height / 2 + fontSize * 0.75}
            textAnchor="middle"
            dominantBaseline="middle"
            style={{ fill: 'rgba(255,255,255,0.85)', fontSize: fontSize * 0.9, fontWeight: 500 }}
          >
            {pct}
          </text>
        </>
      )}
      {showLabel && !showTwoLine && (
        <text
          x={x + width / 2}
          y={y + height / 2}
          textAnchor="middle"
          dominantBaseline="middle"
          style={{ fill: '#fff', fontSize, fontWeight: 600 }}
        >
          {name}
        </text>
      )}
    </g>
  );
};

const PositionTreemap: React.FC<Props> = ({ data }) => {
  if (!data || data.length === 0) {
    return <div className="chart-empty">No position data.</div>;
  }
  return (
    <div className="chart-container">
      <ResponsiveContainer width="100%" height={165}>
        <Treemap
          data={data}
          dataKey="size"
          content={<CustomContent />}
        >
          <Tooltip formatter={(v: any) => [`${Number(v).toFixed(2)}%`, 'of NAV']} />
        </Treemap>
      </ResponsiveContainer>
    </div>
  );
};

export default PositionTreemap;
